import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { IBaseInvoice } from 'src/types/invoices';
import type { IAIPaymentSuggestion } from 'src/types/payments';

type PaymentMatchingState = {
  selectedAISuggestion: IAIPaymentSuggestion | null;
  selectedSearchSuggestion: IBaseInvoice | null;
  selectedAllocationSuggestion: IAIPaymentSuggestion | null;
};

const initialState: PaymentMatchingState = {
  selectedAISuggestion: null,
  selectedSearchSuggestion: null,
  selectedAllocationSuggestion: null,
};

export const paymentMatchingSlice = createSlice({
  name: 'paymentMatching',
  initialState,
  reducers: {
    setSelectedAISuggestion(state, action: PayloadAction<IAIPaymentSuggestion | null>) {
      state.selectedAISuggestion = action.payload;
      state.selectedSearchSuggestion = null; // Clear search suggestion when AI suggestion is selected
    },
    setSelectedSearchSuggestion(state, action: PayloadAction<IBaseInvoice | null>) {
      state.selectedSearchSuggestion = action.payload;
      state.selectedAISuggestion = null; // Clear AI suggestion when search suggestion is selected
    },
    setSelectedAllocationSuggestion(state, action: PayloadAction<IAIPaymentSuggestion | null>) {
      state.selectedAllocationSuggestion = action.payload;
    },
  },
});

export const {
  setSelectedAISuggestion,
  setSelectedSearchSuggestion,
  setSelectedAllocationSuggestion,
} = paymentMatchingSlice.actions;

export default paymentMatchingSlice.reducer;
